module.exports = __webpack_public_path__ + "assets/1d1770e75e75ed7d088870c455c62331.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/hu/video.mp4
// module id = 347
// module chunks = 1